const initialState = () => ({
  websocket: null,
  connectionStatus: "disconnected", // "disconnected" | "connecting" | "connected"
  connId: null,

  showingNotification: false,

  messages: [],
  updates: [],
  notification: null,

  NOTIFICATION_EVENTS: ["MESSAGE_RECEIVED"],
  OMNICHANNEL_EVENTS: ["MESSAGE_RECEIVED", "MESSAGE_STATUS", "SEND_MESSAGE"],
  UPDATE_EVENTS: ["USER_PRESENCE_UPDATED"],
});

const getters = {};

const actions = {
  sendPong({ state }) {
    if (state.websocket) {
      state.websocket.send(
        JSON.stringify({
          event: "PONG",
        }),
      );
    }
  },

  unsubscribeChannel({ state, rootGetters }, dialogId) {
    if (!state.websocket || !dialogId) return;

    const role = rootGetters["app/getUserRole"];

    if (["salesRep", "gerador"].includes(role)) return;

    state.websocket.send(
      JSON.stringify({
        event: "UNSUBSCRIBE_CHANNEL",
        payload: { dialog_id: dialogId },
      }),
    );
  },

  unsubscribeAll({ state, rootGetters }) {
    if (!state.websocket) return;

    const role = rootGetters["app/getUserRole"];

    if (["salesRep", "gerador"].includes(role)) return;

    state.websocket.send(JSON.stringify({ event: "UNSUBSCRIBE_ALL" }));
  },

  handleMessage({ state, dispatch, commit }, message) {
    if (message.event === "PING") {
      dispatch("sendPong");

      if (message.data?.type === "connection_established" && message.data?.conn_id) {
        commit("setConnId", message.data.conn_id);
      }

      return;
    }

    if (state.UPDATE_EVENTS.includes(message.event)) {
      state.updates.push(message);

      return;
    }

    if (state.OMNICHANNEL_EVENTS.includes(message.event)) message.fromOmnichannel = true;

    message.fromBot = Boolean(
      message.data?.bot_id ||
        message.data?.bot_name ||
        message.bot_id ||
        message.bot_name,
    );

    if (
      state.NOTIFICATION_EVENTS.includes(message.event) &&
      !state.showingNotification &&
      !message.fromBot
    ) {
      commit("setNotification", message);
    }

    state.messages.push(message);
  },
};

const mutations = {
  setConnectionStatus(state, status) {
    state.connectionStatus = status;
  },

  setConnId(state, connId) {
    state.connId = connId;
  },

  setWebsocket(state, websocket) {
    state.websocket = websocket;
  },

  setShowingNotification(state, showing) {
    state.showingNotification = showing;
  },

  setNotification(state, notification) {
    state.notification = notification;
  },
};

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
};
